var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPbnaIconDp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 44.5C34.1503 44.5 44 34.6503 44 22.5C44 10.3497 34.1503 0.5 22 0.5C9.84974 0.5 0 10.3497 0 22.5C0 34.6503 9.84974 44.5 22 44.5ZM14.008 11.1005V33.5005H18.168V27.0365H23.224C25.208 27.0365 26.904 26.7165 28.312 26.0765C29.7413 25.4365 30.84 24.5192 31.608 23.3245C32.376 22.1298 32.76 20.7112 32.76 19.0685C32.76 17.4258 32.376 16.0072 31.608 14.8125C30.84 13.6178 29.7413 12.7005 28.312 12.0605C26.904 11.4205 25.208 11.1005 23.224 11.1005H14.008ZM18.168 23.5165H23.032C24.8667 23.5165 26.2427 23.1325 27.16 22.3645C28.0987 21.5752 28.568 20.4765 28.568 19.0685C28.568 17.6392 28.0987 16.5405 27.16 15.7725C26.2427 15.0045 24.8667 14.6205 23.032 14.6205H18.168V23.5165Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPbnaIconDp);
export default __webpack_public_path__ + "static/media/pbna-icon-dp.59cf94f1b539262469d6702b3b2d1d51.svg";
export { ForwardRef as ReactComponent };